import { http } from '@/api/_base';

const send_command = (command: string, token: string) => {
	return http
		.post(
			'minecraft/cmd',
			{
				token: token,
				command: command
			},
			{
				withCredentials: true
			}
		)
		.then(res => res.data);
};

const get_logs = (token: string) => {
	return http
		.get('/minecraft', {
			params: { token: token },
			withCredentials: true
		})
		.then(res => res.data);
};

export { send_command, get_logs };
